export enum PolicyMenuEnum {
    PERSONAL = 'personal',
    HISTORY_CAR_USAGE = 'historyCarUsage',
    RETURN_COVERAGE_HOUR = 'returnCoverageHour',
  }
  